module.exports = __webpack_public_path__ + "static/img/banner.912508e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/banner.png
// module id = zE2k
// module chunks = 0